import { of } from 'rxjs';
import { ProviderDataAdapter } from '../provider-data-adapter';
import { isUserRejectError } from '../wallet-errors';
import { createClient, createClientAndSyncChain } from './create-client-and-sync-chain';
export class UniversalBrowserExtensionAdapter {
    get info() {
        return this.providerDetail.info;
    }
    constructor(providerDetail) {
        this.providerDetail = providerDetail;
        this.client = null;
        this.data = new ProviderDataAdapter(this.providerDetail.info);
    }
    async connect(chainId) {
        this.client = await createClientAndSyncChain(chainId, this.providerDetail.provider);
        this.data.setProvider(this.providerDetail.provider);
        return true;
    }
    async restoreConnect(chainId, force) {
        this.data.setProvider(this.providerDetail.provider);
        const addresses = await this.data.getAddresses();
        const walletChainId = await this.data.getChainId();
        const state = addresses.length > 0;
        if (!state) {
            this.data.setProvider(null);
        }
        else {
            this.client = createClient(chainId, this.providerDetail.provider);
        }
        if (!state && force && walletChainId === null) {
            return this.connect(chainId);
        }
        if (!state && force && walletChainId !== null) {
            this.connect(chainId).catch();
        }
        return state;
    }
    async disconnect() {
        this.client = null;
        this.data.setProvider(null);
        this.setActiveAddress(null);
        return true;
    }
    async changeChain(chainId) {
        if (!this.client)
            return false;
        await this.client.switchChain({ id: chainId });
        return true;
    }
    async isConnected() {
        const addresses = (await this.client?.getAddresses()) ?? [];
        return addresses.length > 0;
    }
    setActiveAddress(address) {
        this.data.setActiveAddress(address);
    }
    async writeContract(params) {
        if (!(await this.isConnected()) || !this.client) {
            throw new Error('Wallet not connected');
        }
        const address = (await this.data.getActiveAddress());
        return await this.client.writeContract({
            ...params,
            account: address,
        });
    }
    async signTypedData(typeData) {
        if (!(await this.isConnected()) || !this.client) {
            throw new Error('Wallet not connected');
        }
        const address = (await this.data.getActiveAddress());
        try {
            return await this.client.signTypedData({
                ...typeData,
                account: address,
            });
        }
        catch (error) {
            if (isUserRejectError(error)) {
                throw error;
            }
            console.error(error);
        }
        const data = JSON.stringify(typeData, stringifyReplacer);
        return (await this.providerDetail.provider.request({
            method: 'eth_signTypedData_v3',
            params: [address, data],
        }));
    }
    connectionUriLink() {
        return of(null);
    }
    async isSupportConnectionUriLink() {
        return false;
    }
}
function stringifyReplacer(_, value) {
    if (typeof value === 'bigint') {
        return value.toString();
    }
    return value;
}
//# sourceMappingURL=universal-browser-extension-adapter.js.map